import React     from 'react';
import PropTypes from 'prop-types';

import * as S           from '../cancel-ar-modal/survey-modal/survey-modal.module.scss';
import { ModalWrapper } from '../modal-wrapper';
import { ForceClose }   from '../force-close';
import { Message }      from '../../common/message';
import { TileQkn }      from '../../pages/subscriptions/tile-qkn/tile-qkn';
import { useGlobalCtx } from '../../../context/ctx-hook';
import { getAlertInfo } from '../../../context/selectors/product-selectors';
import { SingleProductRow } from '../../pages/subscriptions/unified-sub-tile/product-single-row';
import { getSubscription } from '../../../context/selectors/product-selectors';

const AlertModal = ({onClose}) => {
  const {state}                   = useGlobalCtx();
  const {product, title, message} = getAlertInfo(state) ?? {};
  const SUB = getSubscription(state, product);

  if (!product) return <ForceClose onClose={onClose}/>;

  return (
    <ModalWrapper heading="Your subscription is expiring soon" onClose={onClose}>
      <div className={S.modalBody}>
        <Message type="INFO" title={title} messages={[message]}/>
        {['quicken-us', 'quicken-ca'].includes(product.toLowerCase()) && <TileQkn isModal />}
        {product === 'acme' && <SingleProductRow sub={SUB} />}
        {product === 'billmanager' && <SingleProductRow sub={SUB} />}
        {product === 'quicken-estate-manager' && <SingleProductRow sub={SUB} onClose={onClose}/>}
        {product === 'quicken-online-backup' && <SingleProductRow sub={SUB} onClose={onClose} />}
      </div>
    </ModalWrapper>
  );
};

AlertModal.displayName = 'AlertModal';

AlertModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  ctx:     PropTypes.object.isRequired
};

export { AlertModal };
